import React from 'react';
import styled from 'styled-components';
import {
  SectionHeading,
  SectionHeadline
} from '../styled';

const SectionHeaderContainer = styled.div`
  ${({ bg }) => bg === 'grey' && `background: #f7f7f7;`}
  ${({ bg }) => bg === 'light grey' && `background: #fafafa;`}
  padding-top: 49px;
  padding-bottom: 50px;
  text-align: center;
  line-height: 38px;
`;

const SectionHeaderInner = styled.div`
  max-width: 1050px;
  padding: 0 25px;
  margin: 0 auto;
`;

const Paragraph = styled.div`
  color: #666666;
  padding-top: 50px;
  font-size: 22px;
  font-weight: 300;
  line-height: 28px;
`;

function SectionHeader({ input }) {
  const { primary } = input;
  const anchorId = primary.description.text.toLowerCase().replace(/ /g, '');

  return (
    <SectionHeaderContainer bg={primary.background_color} id={anchorId}>
      <SectionHeaderInner>
        {primary.tagline &&
          <SectionHeading>{primary.tagline.text}</SectionHeading>
        }
        {primary.description &&
          <SectionHeadline>{primary.description.text}</SectionHeadline>
        }
        {primary.paragraph &&
          <Paragraph>{primary.paragraph.text}</Paragraph>
        }
      </SectionHeaderInner>
    </SectionHeaderContainer>
  );
}

export { SectionHeader };
